"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../common/js/components/GlobalModal");
const LoadingSpinner_1 = __importStar(require("../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Tooltip_1 = __importDefault(require("../atoms/Tooltip"));
const TooltipPosition_1 = __importDefault(require("../enums/TooltipPosition"));
const DelegationStore_1 = __importDefault(require("../stores/DelegationStore"));
const ProfileStore_1 = __importDefault(require("../stores/ProfileStore"));
const ChangeCompanyProfileModal_1 = __importDefault(require("./ChangeCompanyProfileModal"));
const MessageModal_1 = __importDefault(require("./MessageModal"));
class CompanySwitch extends react_1.default.Component {
    scopeReactionDisposer;
    backToOriginalCustomerLoading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            backToOriginalCustomerLoading: mobx_1.observable,
            hasAtLeastOneAdditionalCustomer: mobx_1.computed,
            hasCompanyChangeButtons: mobx_1.computed,
            isDelegatedCustomer: mobx_1.computed,
            originalCustomerName: mobx_1.computed,
            originalCustomerNameNonBreakingSpaces: mobx_1.computed,
            backToOriginalCustomer: mobx_1.action.bound,
        });
    }
    get hasAtLeastOneAdditionalCustomer() {
        return ProfileStore_1.default.customerOptions.length > 0;
    }
    get hasCompanyChangeButtons() {
        return !this.backToOriginalCustomerLoading && !ProfileStore_1.default.isLoading && this.hasAtLeastOneAdditionalCustomer;
    }
    get isDelegatedCustomer() {
        return (null !== AuthorizationStore_1.default.originalCustomerId &&
            AuthorizationStore_1.default.originalCustomerId !== AuthorizationStore_1.default.customerId &&
            null !== this.originalCustomerNameNonBreakingSpaces);
    }
    get originalCustomerName() {
        const id = AuthorizationStore_1.default.originalCustomerId;
        if (!id) {
            return null;
        }
        return ProfileStore_1.default.customers.find((customer) => id === customer.customerId)?.customerName ?? null;
    }
    get originalCustomerNameNonBreakingSpaces() {
        const name = this.originalCustomerName?.replace(/\s+/g, '\u00A0') ?? null;
        return !name ? null : name;
    }
    componentDidMount() {
        this.scopeReactionDisposer = (0, mobx_1.reaction)(() => [AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.DELEGATE), AuthorizationStore_1.default.customerId], ([hasScope]) => {
            if (hasScope) {
                ProfileStore_1.default.loadOnBehalfOfCustomers();
            }
            else if (!hasScope) {
                ProfileStore_1.default.reset();
            }
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.scopeReactionDisposer?.();
    }
    render() {
        return (react_1.default.createElement("div", { className: "znd-top-bar__company d-flex flex-row align-items-center" },
            react_1.default.createElement("div", { className: "znd-top-bar__company-selector" },
                !this.backToOriginalCustomerLoading &&
                    AuthorizationStore_1.default.customerName &&
                    AuthorizationStore_1.default.customerId ? (react_1.default.createElement("div", { className: "znd-top-bar__company-title t-subhead-small" }, AuthorizationStore_1.default.customerName + ' (' + AuthorizationStore_1.default.customerId + ')')) : null,
                ProfileStore_1.default.isLoading || this.backToOriginalCustomerLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { style: LoadingSpinner_1.LoadingSpinnerStyle.small })) : null,
                react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.DELEGATE] }, this.hasCompanyChangeButtons ? (react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.text, text: (0, translation_1.t)('main_navigation.change_company'), onClick: () => {
                        (0, GlobalModal_1.showModal)({
                            component: ChangeCompanyProfileModal_1.default,
                            dontCloseOnOverlayClick: true,
                            props: {},
                            dialogNotScrollable: true,
                            mainScrollable: true,
                        });
                    } })) : null)),
            react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.DELEGATE] }, this.hasCompanyChangeButtons && this.isDelegatedCustomer ? (react_1.default.createElement(Tooltip_1.default, { position: TooltipPosition_1.default.bottomCenter, label: (0, translation_1.t)('back_to_original_customer.tooltip', {
                    originalCustomerName: this.originalCustomerNameNonBreakingSpaces,
                }), className: "align-self-center" },
                react_1.default.createElement(Button_1.default, { className: "znd-top-bar__company-home", variant: ButtonVariant_1.default.primary, icon: Zupicons_1.default.homeAlt, onClick: () => {
                        (0, GlobalModal_1.showModal)({
                            component: MessageModal_1.default,
                            props: {
                                title: (0, translation_1.t)('back_to_original_customer.modal.title'),
                                body: (0, translation_1.t)('back_to_original_customer.modal.text', {
                                    originalCustomerName: this.originalCustomerNameNonBreakingSpaces,
                                }),
                            },
                        }).then(this.backToOriginalCustomer);
                    } }))) : null)));
    }
    backToOriginalCustomer() {
        if (!AuthorizationStore_1.default.originalCustomerId) {
            return Promise.resolve();
        }
        this.backToOriginalCustomerLoading = true;
        return DelegationStore_1.default.updateDelegationAndRefreshToken(AuthorizationStore_1.default.originalCustomerId).finally((0, mobx_1.action)(() => {
            this.backToOriginalCustomerLoading = false;
        }));
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(CompanySwitch));
